import { blockText } from './TimeGrid/TimeGrid';

/** Chips chicos con las clases del alumno, en el MISMO color que usa el calendario
 *  (pedido Karla: que las clases se aprecien; Carlos 3-jul: "en color como el calendario").
 *  El backend manda "Nombre~#RRGGBB|Nombre~..." (color vacío = fallback gris del TimeGrid). */
const FALLBACK = '#64748b';

export function parseClasses(classes: string | null | undefined): { name: string; color: string }[] {
  if (!classes) return [];
  return classes.split('|').map((tok) => {
    const [name, color] = tok.split('~');
    return { name: (name || '').trim(), color: (color || '').trim() || FALLBACK };
  }).filter((c) => c.name);
}

export default function ClassChips({ classes, max = 2 }: { classes: string | null | undefined; max?: number }) {
  const all = parseClasses(classes);
  if (!all.length) return null;
  const shown = all.slice(0, max);
  const rest = all.length - shown.length;
  return (
    <span className="mt-0.5 flex flex-wrap items-center gap-1">
      {shown.map((c) => (
        <span key={c.name} title={c.name}
          className="max-w-[9.5rem] truncate rounded-full px-1.5 py-[1px] text-[10px] font-semibold leading-4"
          style={{ background: c.color, color: blockText(c.color) }}>
          {c.name}
        </span>
      ))}
      {rest > 0 && (
        <span className="rounded-full border border-line px-1.5 py-[1px] text-[10px] font-medium leading-4 text-content-3">
          +{rest}
        </span>
      )}
    </span>
  );
}
